import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { where } from "firebase/firestore";
import { CommonCloudFirestore } from '../../../services/CommonCloudFirestore';
import { DOCUMENT_COVER, LISTENER_COVERS } from '../../../../shared/types/firestoreType';

import storageManager from '../../../../shared/utility/storageManager';

import './styles.css';

export default function Index(props) {
    const coverFirestore = new CommonCloudFirestore(DOCUMENT_COVER);
    const [covers, setCovers] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        onLoad();
    }, []);

    const onLoad = async () => {
        setLoading(true);
        const condition = where("visible", "==", true);
        const _covers = await storageManager.fetch(LISTENER_COVERS, async () => await coverFirestore.getDocuments(condition));
        setCovers(_covers)
        setLoading(false);
    };

    if (covers?.length === 0)
        return null;

    return (
        <div className='mb-20'>
            <div id="myCarousel" className="carousel slide" data-bs-ride="carousel">
                <div className="carousel-indicators">
                    {
                        covers.map((item, index) => {
                            return (
                                <button
                                    key={item.id}
                                    className={`${index === 0 ? 'active' : ''}`}
                                    type="button"
                                    data-bs-target="#myCarousel"
                                    data-bs-slide-to={index}
                                    aria-label={`Slide ${item.index + 1}`}>
                                </button>
                            )
                        })
                    }
                </div>
                <div className="carousel-inner">
                    {
                        covers.map((item, index) => {
                            return (
                                <div key={index} className={`carousel-item${index === 0 ? ' active' : ''}`}>
                                    <img src={item.imageUrl} className="w-100" alt="..." />
                                    <div className="carousel-caption text-start">
                                        <h1>{item.title}</h1>
                                        <p>{item.subTitle}</p>
                                        <p>
                                            <Link
                                                to={`/product-cover/${item.id}`}
                                                style={{ textDecoration: 'none', color: 'inherit' }}
                                                className="btn btn-lg btn-primary"
                                            >
                                                Ver más
                                            </Link>
                                        </p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#myCarousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#myCarousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
    );
}